import 'css-chunksrc/client/pages/personalSpacePage/timeSheet/loader/allocation/recordList/styles.scss';export default {
  "recordList": "_recordList_irfgq_1",
  "resource": "_resource_irfgq_7",
  "record": "_record_irfgq_1",
  "list": "_list_irfgq_11",
  "task": "_task_irfgq_15",
  "dates": "_dates_irfgq_19",
  "odd": "_odd_irfgq_31",
  "today": "_today_irfgq_34",
  "weekEnd": "_weekEnd_irfgq_37",
  "timeOverview": "_timeOverview_irfgq_41"
};